import { logGreyErrorFromAccounts } from 'owa-account-analytics';
import setCoprincipalAccountPolicyStateMutator from '../actions/setCoprincipalAccountPolicyStateMutator';
import { default as getAccountBySourceId } from '../selectors/getAccountBySourceId';
import getAccountSourceListStore from '../store/accountSourceListStore';
import { accountRankTypeChecker } from '../store/schema/AccountSourceList';
import { PolicyStateTypeEnum } from 'owa-account-source-list-types';
import onAccountBadState from '../actions/onAccountBadState';

/* Validates that the sourceId is valid and then sets the account's policy state
 * @param sourceId id of the coprincipal account
 * @param state state to which the account is to be set
 */
export default function setCoprincipalAccountPolicyState(
    sourceId: string,
    state: PolicyStateTypeEnum | undefined
): void {
    const account = getAccountBySourceId(sourceId);
    if (!accountRankTypeChecker.isCoprincipal(account)) {
        const e = new Error('AcctInit_CannotSetPolicyState_CoprincipalMissing');

        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
         * BASELINE: DO NOT COPY/PASTE!
         *	> Argument at index 1 for logGreyErrorFromAccounts must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
        logGreyErrorFromAccounts('AcctInit_CannotSetPolicyState_CoprincipalMissing', undefined, e, {
            cnt: getAccountSourceListStore().sources.length,
            sid: typeof sourceId,
            sidl: sourceId.length,
        });

        return;
    }

    if (account.policyState === state) {
        // The policy state has not changed
        return;
    }
    if (account.policyState === PolicyStateTypeEnum.PolicyError) {
        onAccountBadState(account.mailboxInfo);
    }

    setCoprincipalAccountPolicyStateMutator(sourceId, state);
}
